import { CheckOutlined } from '@ant-design/icons';
import cn from 'classnames';
import { useCallback, type FC } from 'react';

import '@pages/Integrations/IntegrationsList/components/Add1CIntegrationModal/styles/IntegrationSteps.desktop.scss';

type StepStatus = 'done' | 'active' | 'upcoming';

interface StepView {
  title: string;
}

export interface IntegrationStepsProps {
  steps: StepView[];
  activeStepIndex: number;
}

export const IntegrationSteps: FC<IntegrationStepsProps> = ({
  steps,
  activeStepIndex,
}) => {
  const getStatus = useCallback(
    (index: number): StepStatus => {
      if (index < activeStepIndex) return 'done';
      if (index === activeStepIndex) return 'active';
      return 'upcoming';
    },
    [activeStepIndex]
  );

  return (
    <div className="IntegrationSteps">
      {steps.map(({ title }, index) => {
        const status = getStatus(index);
        const isLast = index === steps.length - 1;
        const step = index + 1;

        return (
          <div key={title} className="IntegrationSteps__item">
            <div className="IntegrationSteps__step">
              <div
                className={cn('IntegrationSteps__circle', {
                  'IntegrationSteps__circle--active': status === 'active',
                  'IntegrationSteps__circle--done': status === 'done',
                })}
              >
                {status === 'done' ? <CheckOutlined /> : step}
              </div>

              <div className="IntegrationSteps__info">
                <div
                  className={cn('IntegrationSteps__stepLabel', {
                    'IntegrationSteps__stepLabel--active': status === 'active',
                    'IntegrationSteps__stepLabel--done': status === 'done',
                  })}
                >
                  Шаг {step}
                </div>

                <div
                  className={cn('IntegrationSteps__title', {
                    'IntegrationSteps__title--active': status === 'active',
                    'IntegrationSteps__title--done': status === 'done',
                  })}
                >
                  {title}
                </div>
              </div>
            </div>

            {!isLast && (
              <div
                className={cn('IntegrationSteps__divider', {
                  'IntegrationSteps__divider--done': status === 'done',
                })}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
